import axios from 'axios';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase-config';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const getAuthHeaders = async (userAuth) =>
{
  const user = userAuth || auth.currentUser;
  if (!user)
  {
    return {};
  }

  const token = await user.getIdToken();
  return {
    Authorization: `Bearer ${token}`
  };
};

const apiError = (error) =>
{
  return error.response?.data?.error || error.message;
};

export const createUserProfile = async (profileData, userAuth) =>
{
  try
  {
    const headers = await getAuthHeaders(userAuth);
    const response = await axios.post(
      `${API_BASE_URL}/api/users/profile`,
      profileData,
      { headers }
    );

    return response.data;
  }
  catch (error)
  {
    console.error('Error creating user profile:', error);
    return { success: false, error: apiError(error) };
  }
};

export const updateProfilePhoto = async (photoURL) =>
{
  try
  {
    const headers = await getAuthHeaders();
    const response = await axios.patch(
      `${API_BASE_URL}/api/users/profile-photo`,
      { photoURL },
      { headers }
    );

    return response.data;
  }
  catch (error)
  {
    console.error('Error updating profile photo:', error);
    return { success: false, error: apiError(error) };
  }
};

export const submitQuestion = async (questionData) =>
{
  try
  {
    const headers = await getAuthHeaders();
    const response = await axios.post(
      `${API_BASE_URL}/api/content/support/questions`,
      questionData,
      { headers }
    );

    return response.data;
  }
  catch (error)
  {
    console.error('Error submitting question:', error);
    return { success: false, error: apiError(error) };
  }
};

export const addMCQtoPS = async (questionData) =>
{
  try
  {
    const headers = await getAuthHeaders();
    const response = await axios.post(
      `${API_BASE_URL}/api/content/problem-set/${questionData.Std}/mcqs`,
      { questionData },
      { headers }
    );

    return response.data;
  }
  catch (error)
  {
    console.error('Error submitting question:', error);
    return { success: false, error: apiError(error) };
  }
};

export const updateProblemSetMCQImage = async (standard, problemId, imageUrl) =>
{
  try
  {
    const headers = await getAuthHeaders();
    const response = await axios.patch(
      `${API_BASE_URL}/api/content/problem-set/${standard}/mcqs/${problemId}/image`,
      { imageUrl },
      { headers }
    );

    return response.data;
  }
  catch (error)
  {
    console.error('Error updating problem-set image:', error);
    return { success: false, error: apiError(error) };
  }
};

export const publishAnnouncement = async (announcementData) =>
{
  try
  {
    const headers = await getAuthHeaders();
    const response = await axios.post(
      `${API_BASE_URL}/api/content/announcements`,
      announcementData,
      { headers }
    );

    return response.data;
  }
  catch (error)
  {
    console.error('Error publishing announcement:', error);
    return { success: false, error: apiError(error) };
  }
};

export const publishBlog = async (blogData) =>
{
  try
  {
    const headers = await getAuthHeaders();
    const response = await axios.post(
      `${API_BASE_URL}/api/content/blogs`,
      {
        title: blogData.BlogTitle,
        content: blogData.BlogData
      },
      { headers }
    );

    return response.data;
  }
  catch (error)
  {
    console.error('Error publishing the blog:', error);
    return { success: false, error: apiError(error) };
  }
};

export const submitBug = async (bugData) =>
{
  try
  {
    const headers = await getAuthHeaders();
    const response = await axios.post(
      `${API_BASE_URL}/api/content/support/bugs`,
      bugData,
      { headers }
    );

    return response.data;
  }
  catch (error)
  {
    console.error('Error submitting bug report:', error);
    return { success: false, error: apiError(error) };
  }
};

export const submitUserQuestion = async (questionData) =>
{
  try
  {
    const headers = await getAuthHeaders();
    const response = await axios.post(
      `${API_BASE_URL}/api/content/user-questions`,
      questionData,
      { headers }
    );

    return response.data;
  }
  catch (error)
  {
    console.error('Error submitting question:', error);
    return { success: false, error: apiError(error) };
  }
};

export const updateUserQuestionImage = async (questionId, imageUrl) =>
{
  try
  {
    const headers = await getAuthHeaders();
    const response = await axios.patch(
      `${API_BASE_URL}/api/content/user-questions/${questionId}/image`,
      { imageUrl },
      { headers }
    );

    return response.data;
  }
  catch (error)
  {
    console.error('Error updating question image:', error);
    return { success: false, error: apiError(error) };
  }
};

export const getUserRatingHistory = async (username) =>
{
  try
  {
    const userRef = doc(db, 'users', username);
    const userDoc = await getDoc(userRef);

    if (!userDoc.exists())
    {
      return [];
    }

    return userDoc.data().ratingHistory || [];
  }
  catch (error)
  {
    console.error('Error fetching rating history:', error);
    return [];
  }
};
